import { ConsoleInstrumentation, ConsoleTransport, ErrorsInstrumentation, faro, FetchTransport, getWebInstrumentations, LogLevel, SessionInstrumentation, ViewInstrumentation, WebVitalsInstrumentation, initializeFaro } from '@grafana/faro-web-sdk';
import AppConfig from '@/configLoader';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
function remoteLoggingAllowed() {
    return AppConfig.getConfig()?.features.grafana_faro == true;
}
export function initFaro() {
    if (remoteLoggingAllowed()) {
        let transports = [];
        let instrumentations = [];
        if (AppConfig.getConfig().faro.transports.fetch) {
            transports.push(new FetchTransport({
                url: AppConfig.getConfig().faro.address
            }));
        }
        if (AppConfig.getConfig().faro.transports.console) {
            transports.push(new ConsoleTransport({
                level: LogLevel.DEBUG
            }));
        }
        if (AppConfig.getConfig().faro.instruments.allWeb) {
            instrumentations.push(...getWebInstrumentations());
        }
        if (AppConfig.getConfig().faro.instruments.console) {
            instrumentations.push(new ConsoleInstrumentation({
                disabledLevels: [LogLevel.LOG, LogLevel.DEBUG, LogLevel.INFO]
            }));
        }
        if (AppConfig.getConfig().faro.instruments.tracing) {
            instrumentations.push(new TracingInstrumentation({}));
        }
        if (AppConfig.getConfig().faro.instruments.session) {
            instrumentations.push(new SessionInstrumentation());
        }
        if (AppConfig.getConfig().faro.instruments.view) {
            instrumentations.push(new ViewInstrumentation());
        }
        if (AppConfig.getConfig().faro.instruments.errors) {
            instrumentations.push(new ErrorsInstrumentation());
        }
        if (AppConfig.getConfig().faro.instruments.webVitals) {
            instrumentations.push(new WebVitalsInstrumentation());
        }
        initializeFaro({
            app: {
                name: 'Rdas.LogHub.Frontend',
                version: VERSION,
                release: BRANCH
            },
            instrumentations: instrumentations,
            transports: transports
        });
    }
}
export function setFaroUser(userId, selectedDepartmentId) {
    if (remoteLoggingAllowed() == false)
        return;
    faro.api.setUser({
        // Optional, if you want to pass the user ID
        id: userId,
        // Optional, if you want to set custom attributes
        attributes: {
            'selected-department-id': selectedDepartmentId
        }
    });
}
export function logEvent(event, data = {}) {
    if (remoteLoggingAllowed() == false)
        return;
    faro.api.pushEvent(event, data, 'customEvent');
}
export function logError(error, type, message) {
    if (remoteLoggingAllowed() == false)
        return;
    faro.api.pushError(error, {
        type: type,
        context: {
            message: message
        }
    });
}
